import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import YootDisplay from '../YootDisplay.jsx';

export default function BlogYutLogo() {
  return <div className="blog-yut-logo" aria-hidden="true">
    <Canvas camera={{ position: [0, 0.5, 8], fov: 28 }} dpr={[1, 1.5]}>
      <ambientLight intensity={1.8} />
      <directionalLight position={[3, 4, 5]} intensity={2.5} />
      <Suspense fallback={null}>
        <YootDisplay
          position={[0, 0, 0]}
          rotation={[Math.PI/2 - Math.PI/8, Math.PI/2, 0]}
          scale={0.15}
          float={false}
          enableHoverEffect={true}
        />
      </Suspense>
    </Canvas>
  </div>;
}